export enum ReservationStatus {
  BOOKED = 'BOOKED',
  CANCELLED = 'CANCELLED',
  DELETED = 'DELETED',
  MODIFIED = 'MODIFIED',
}

export enum ReservationState {
  PAST = 'PAST',
  FUTURE = 'FUTURE',
  CURRENT = 'CURRENT',
}

export interface ReservationDate {
  status: ReservationStatus | string;
  state: ReservationState | string;
  confirmationCode: string;
  adults: string | number;
  children: string | number;
  checkInDate: string;
  checkOutDate: string;
  propertyCode: string;
  propertyName: string;
  roomType: string;
  roomTypeTitle: string;
  regionCode: string;
  lastName: string;
  reservationID: string;
}

export type Reservation = ReservationDate;

export interface ReservationsResponse {
  readonly userid: string;
  readonly firstname: string;
  readonly lastname: string;
  readonly reservations: Reservation[];
}
